import { Outlet } from 'react-router-dom'

import { FlexLayout } from 'components'

import './styles.scss'

export const ScrollableContentLayout = () => {
  return (
    <FlexLayout.Container vertical>
      <FlexLayout.Content className="scrollable-layout">
        <Outlet />
      </FlexLayout.Content>
    </FlexLayout.Container>
  )
}
